import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { SpinLink } from '@webmotors/buyer-design-system'
import { onClientSide, sendDispatchEvent } from '@/utils/utils'
import './styles.scss'
import { EVENT_DICTIONARY } from './dataAnalytics'

const Spin = ({ image, onClick }) => {
  const dispatchSpinEvent = useCallback(event => {
    if (typeof event.data !== 'string') return

    const STS_PREFIX = 'sts-post-analytics:'
    const URL_ORIGIN = [
      'https://spins.spincar.com',
      'https://embed.spincar.com',
    ]

    if (
      !URL_ORIGIN.includes(event.origin) ||
      event.data.indexOf(STS_PREFIX) !== 0
    )
      return

    const message = JSON.parse(event.data.substring(STS_PREFIX.length))

    sendDispatchEvent(EVENT_DICTIONARY[message.event])
  }, [])

  useEffect(() => {
    if (onClientSide()) {
      window.addEventListener('message', dispatchSpinEvent)
    }

    return () => {
      if (onClientSide()) {
        window.removeEventListener('message', dispatchSpinEvent)
      }
    }
  }, [dispatchSpinEvent])

  return (
    <div
      data-testid="carousel-item-spin"
      id="DetailCarouselContainerItems-00"
      className="DetailCarousel__container__items"
    >
      <SpinLink image={image} onClick={onClick} />
    </div>
  )
}

Spin.propTypes = {
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Spin
